export const ManageContactsDialogFlavour = {
  AddressBook: 0,
  ModifyAfterBooking: 1,
} as const;
export type ManageContactsDialogFlavour =
  (typeof ManageContactsDialogFlavour)[keyof typeof ManageContactsDialogFlavour];
